/**
 * Block model of v2 lessons (Autorentool v2). Mirrors the backend schema in
 * `online-academy-api/src/Block/BlockSchemaRegistry.php`: every block is
 * `{ id, type, data, meta? }`, stored as `lesson.content.blocks`.
 */
export interface Block {
    id: string;
    type: string;
    data: Record<string, unknown>;
    meta?: Record<string, unknown>;
}

export type CompletionRule = 'view_only' | 'scroll_through' | 'all_interactions' | 'quiz_passed' | 'manual';

export const COMPLETION_RULES: CompletionRule[] = ['view_only', 'scroll_through', 'all_interactions', 'quiz_passed', 'manual'];

/** `lesson.content` of a block lesson as the API delivers and accepts it. */
export interface BlockLessonContent {
    schemaVersion?: number;
    completionRule?: CompletionRule;
    blocks: Block[];
    /** Set by the API when answer keys were stripped for a learner. */
    answerKeysStripped?: boolean;
}

export type BlockCategory = 'content' | 'layout' | 'interactive';
